import Styles from "./badge.module.scss";

const Badge = ({ message }) => {
  return <span className={Styles.Badge}>{message}</span>;
};

export default Badge;
